/* Folk & Fire — theme behaviour
   Vanilla JS, no dependencies. Progressive enhancement only. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  /* ---------------------------------------------------------------- toast */
  var toastEl = $('#Toast');
  var toastTimer = null;

  function toast(message, detail) {
    if (!toastEl) return;
    var text = $('.toast__text', toastEl);
    if (text) text.textContent = detail ? detail + ' — ' + message : message;
    toastEl.hidden = false;
    // force paint so the transition runs
    void toastEl.offsetWidth;
    toastEl.setAttribute('data-visible', 'true');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.setAttribute('data-visible', 'false');
      setTimeout(function () {
        toastEl.hidden = true;
      }, 320);
    }, 3200);
  }

  /* ----------------------------------------------------------- mobile nav */
  var navDrawer = $('[data-mobile-nav]');
  var overlay = $('[data-overlay]');

  function setDrawer(open) {
    if (!navDrawer) return;
    navDrawer.setAttribute('data-open', String(open));
    navDrawer.setAttribute('aria-hidden', String(!open));
    if (overlay) overlay.setAttribute('data-open', String(open));
    document.body.style.overflow = open ? '' : '';
    $$('[data-nav-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', String(open));
    });
  }

  $$('[data-nav-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isOpen = navDrawer && navDrawer.getAttribute('data-open') === 'true';
      setDrawer(!isOpen);
    });
  });

  if (overlay) {
    overlay.addEventListener('click', function () {
      setDrawer(false);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      setDrawer(false);
      var search = $('[data-search-panel]');
      if (search) search.hidden = true;
    }
  });

  /* -------------------------------------------------------------- quantity */
  $$('[data-quantity]').forEach(function (wrapper) {
    var input = $('input', wrapper);
    if (!input) return;
    $$('[data-quantity-step]', wrapper).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-quantity-step'), 10) || 1;
        var min = parseInt(input.getAttribute('min'), 10);
        var max = parseInt(input.getAttribute('max'), 10);
        var next = (parseInt(input.value, 10) || 0) + step;
        if (!isNaN(min) && next < min) next = min;
        if (!isNaN(max) && max > 0 && next > max) next = max;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* --------------------------------------------------- product image switch */
  $$('[data-product-gallery]').forEach(function (gallery) {
    var main = $('[data-gallery-main]', gallery);
    $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        if (src) main.setAttribute('src', src);
        if (srcset) {
          main.setAttribute('srcset', srcset);
        } else {
          main.removeAttribute('srcset');
        }
        $$('[data-gallery-thumb]', gallery).forEach(function (other) {
          other.setAttribute('aria-current', String(other === thumb));
        });
      });
    });
  });

  /* ------------------------------------------------------- add to cart (xhr) */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshCartCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
      })
      .catch(function () {
        /* silent — the count is cosmetic */
      });
  }

  $$('form[data-ajax-cart], form.product-form').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!window.fetch || !window.FormData) return; // let the browser do it
      event.preventDefault();

      var button = $('[data-add-button]', form);
      var label = button ? button.textContent : '';
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.textContent = '…';
      }

      var body = new FormData(form);
      body.append('sections', '');

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status && data.status !== 200) {
            toast(data.description || data.message || 'Something went wrong.');
            return;
          }
          refreshCartCount();
          var title = (data.items && data.items[0] && data.items[0].product_title) || '';
          toast(
            (window.themeStrings && window.themeStrings.added) || 'Added to basket',
            title
          );
        })
        .catch(function () {
          toast('Could not add to basket. Please try again.');
        })
        .finally(function () {
          if (button) {
            button.removeAttribute('aria-disabled');
            button.textContent = label;
          }
        });
    });
  });

  /* ------------------------------------------------ cart quantity autosubmit */
  $$('[data-cart-quantity]').forEach(function (input) {
    var timer = null;
    input.addEventListener('change', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var form = input.closest('form');
        if (form) form.submit();
      }, 400);
    });
  });

  /* ------------------------------------------------------ scroll reveal (mild) */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-revealed', 'true');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    $$('[data-reveal]').forEach(function (el) {
      observer.observe(el);
    });
  } else {
    $$('[data-reveal]').forEach(function (el) {
      el.setAttribute('data-revealed', 'true');
    });
  }

  /* --------------------------------------------------------- search toggle */
  $$('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = $('[data-search-panel]');
      if (!panel) return;
      panel.hidden = !panel.hidden;
      if (!panel.hidden) {
        var input = $('input[type="search"]', panel);
        if (input) input.focus();
      }
    });
  });

  /* --------------------------------------------- address form (country/province) */
  var addressSelect = $('[data-address-country]');
  if (addressSelect && window.Shopify && window.Shopify.countryProvinceSelector) {
    var addressForm = addressSelect.closest('form') || document;
    var provinceContainer = $('[id^="AddressProvinceContainer"]', addressForm);
    new window.Shopify.countryProvinceSelector(
      addressSelect.id,
      provinceContainer ? provinceContainer.id.replace('Container', '') : 'AddressProvince',
      { hideElement: provinceContainer ? provinceContainer.id : 'AddressProvinceContainer' }
    );
  }

  /* ----------------------------------------------------- sticky header shadow */
  var header = $('.site-header');
  if (header) {
    window.addEventListener(
      'scroll',
      function () {
        var y = window.scrollY;
        header.style.boxShadow = y > 12 ? '0 10px 24px -22px rgba(33,28,23,0.9)' : 'none';
      },
      { passive: true }
    );
  }

  /* ----------------------------------------------------------- slideshow */
  $$('[data-slideshow]').forEach(function (root) {
    var track = $('[data-slideshow-track]', root);
    var slides = $$('[data-slide]', root);
    if (!track || slides.length < 2) return;

    var dots = $$('[data-slide-dot]', root);
    var toggle = $('[data-slide-toggle]', root);
    var prevBtn = $('[data-slide-prev]', root);
    var nextBtn = $('[data-slide-next]', root);

    var index = 0;
    var timer = null;
    var playing = root.getAttribute('data-autoplay') === 'true';
    var speed = (parseInt(root.getAttribute('data-speed'), 10) || 6) * 1000;
    var reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function render() {
      track.style.transform = 'translate3d(' + -index * 100 + '%, 0, 0)';
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!playing || reduced || document.hidden) return;
      timer = setInterval(function () {
        index = (index + 1) % slides.length;
        render();
      }, speed);
    }

    function go(target, fromUser) {
      index = (target + slides.length) % slides.length;
      render();
      if (fromUser) start();
    }

    function setPlaying(next) {
      playing = next;
      if (toggle) {
        toggle.setAttribute('aria-pressed', next ? 'false' : 'true');
        toggle.setAttribute('aria-label', next ? 'Pause slideshow' : 'Play slideshow');
      }
      if (next) start();
      else stop();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        go(index - 1, true);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        go(index + 1, true);
      });
    }
    if (toggle) {
      toggle.addEventListener('click', function () {
        setPlaying(!playing);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        go(i, true);
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        go(index - 1, true);
        event.preventDefault();
      } else if (event.key === 'ArrowRight') {
        go(index + 1, true);
        event.preventDefault();
      }
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', function () {
      if (playing) start();
    });
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget) && playing) start();
    });

    // touch: horizontal swipe changes slide, vertical swipe scrolls the page
    var startX = 0;
    var startY = 0;
    var deltaX = 0;
    var dragging = false;
    var lockedAxis = false;

    track.addEventListener(
      'touchstart',
      function (event) {
        if (event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        deltaX = 0;
        dragging = true;
        lockedAxis = false;
        stop();
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      function (event) {
        if (!dragging || event.touches.length !== 1) return;
        var dx = event.touches[0].clientX - startX;
        var dy = event.touches[0].clientY - startY;
        if (!lockedAxis && Math.abs(dx) < Math.abs(dy)) {
          dragging = false;
          return;
        }
        lockedAxis = true;
        deltaX = dx;
      },
      { passive: true }
    );

    track.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      if (Math.abs(deltaX) > 45) {
        go(index + (deltaX < 0 ? 1 : -1), true);
      } else if (playing) {
        start();
      }
      deltaX = 0;
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else if (playing) start();
    });

    render();
    start();
  });
})();
